import FileShared from './FileShared.js'
import FileSharedPermission from './FileSharedPermission.js'
import FileStoppedSharing from './FileStoppedSharing.js'
import FileZipped from './FileZipped.js'
import FileDownloadUpdated from './FileDownloadUpdated.js'
import SilentNotification from './SilentNotification.js'
import FileSharedNewAggregate from './FileSharedNewAggregate.js'

const mappedNotifications = {}

;([
  FileShared,
  FileSharedPermission,
  FileStoppedSharing,
  FileZipped,
  FileDownloadUpdated,
  SilentNotification,
  FileSharedNewAggregate
]).forEach(notification => {
  if (!notification.name) {
    console.error(notification)
    throw new Error('You must define a name attribute for the notification')
  }

  mappedNotifications[notification.name] = notification
})

export default mappedNotifications



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/_all.js